import { ModuleNames } from '../../src/constants/componentNames.constants'

const moduleMapping: { [key: string]: string } = {
  componentBio: ModuleNames.BIO,
  componentHero: ModuleNames.HERO,
  componentFlexibleHero: ModuleNames.FLEXIBLE_HERO,
  componentTiles: ModuleNames.TILES,
  componentFeaturedResource: ModuleNames.FEATURED_RESOURCE,
  componentFeaturedTiles: ModuleNames.FEATURED_TILES,
  componentAssetText: ModuleNames.MEDIA_TEXT,
  componentIcons: ModuleNames.ICONS,
  componentSpotlight: ModuleNames.VIDEO_SPOTLIGHT,
  componentDivider: ModuleNames.DIVIDER,
  componentContentBlock: ModuleNames.GLOBAL_CONTENT_BLOCK,
  componentContentRows: ModuleNames.CONTENT_ROWS,
  componentCollapsibleQuadrant: ModuleNames.COLLAPSIBLE_QUADRANT,
  componentGrid: ModuleNames.GRID,
  componentMainCta: ModuleNames.GLOBAL_MAIN_CTA,
  componentKeyStats: ModuleNames.GLOBAL_KEY_STATS,
  componentBenefits: ModuleNames.BENEFITS,
  componentPlatformDiagram: ModuleNames.PLATFORM_DIAGRAM,
  componentQuote: ModuleNames.QUOTE,
  componentColumns: ModuleNames.GLOBAL_CONTENT_COLUMNS,
  componentResourceTabs: ModuleNames.RESOURCE_TABS,
  componentMediaAsset: ModuleNames.MEDIA_ASSET,
  componentResourceRow: ModuleNames.RESOURCE_ROW,
  componentResourceLists: ModuleNames.RESOURCE_LISTS,
  componentParagraphBlock: ModuleNames.PARAGRAPH_BLOCK,
  componentTable: ModuleNames.TABLE,
  componentSlider: ModuleNames.SLIDER,
  componentMarketoForm: ModuleNames.MARKETO_FORM,
  componentProductDownload: ModuleNames.PRODUCT_DOWNLOAD_COMPONENT,
  componentSpeakerText: ModuleNames.SPEAKER_TEXT,
  componentRawHtml: ModuleNames.RAW_HTML,
  teaser: ModuleNames.TEASER,
  pageResource: ModuleNames.PAGE_CUSTOMER_STORY,
  pageWhitePaper: ModuleNames.PAGE_WHITE_PAPER,
  pageAnalystReport: ModuleNames.PAGE_ANALYST_REPORT,
  pagePlaceholder: ModuleNames.PAGE_PLACEHOLDER,
  pageResourceDemo: ModuleNames.PAGE_RESOURCE_DEMO,
  pageAboutRpa: ModuleNames.PAGE_ABOUT_RPA,
  pageBlogPost: ModuleNames.BLOG_POST,
  pageMainBlog: ModuleNames.PAGE_MAIN_BLOG,
  pageFlex: ModuleNames.PAGE_FLEX,
  pageSolutions: ModuleNames.PAGE_SOLUTIONS,
  pageRawHtml: ModuleNames.PAGE_RAW_HTML,
  wrapperPdf: ModuleNames.WRAPPER_PDF,
  WrapperAsset: ModuleNames.WRAPPER_ASSET,
  wrapperVideo: ModuleNames.WRAPPER_VIDEO,
  topicAutomationUseCase: ModuleNames.AUTOMATION_USE_CASE,
  topicAnchorLink: ModuleNames.ANCHOR_LINK,
  topicCustomerDetails: ModuleNames.TOPIC_CUSTOMER_DETAILS,
  topicCta: ModuleNames.TOPIC_CTA,
  topicInternalLink: ModuleNames.TOPIC_INTERNAL_LINK,
  topicMediaTiles: ModuleNames.TOPIC_MEDIA_TILES,
  topicFaq: ModuleNames.TOPIC_FAQ,
  topicAgenda: ModuleNames.TOPIC_AGENDA,
  topicResourceIndustry: ModuleNames.TOPIC_INDUSTRY,
  topicResourceDepartment: ModuleNames.TOPIC_DEPARTMENT,
  topicResourceTopic: ModuleNames.TOPIC_RESOURCE_TOPIC,
  topicResourceProduct: ModuleNames.TOPIC_RESOURCE_PRODUCT,
  topicWebinarType: ModuleNames.TOPIC_WEBINAR_TYPE,
  topicResourceRegion: ModuleNames.TOPIC_REGION,
  topicOfficeRegion: ModuleNames.TOPIC_OFFICE_REGION,
  topicIconLink: ModuleNames.TOPIC_ICON_LINK,
  topicCompanyBio: ModuleNames.TOPIC_COMPANY_BIO,
  topicPartnerDetails: ModuleNames.TOPIC_PARTNER_DETAILS,
  topicEventType: ModuleNames.TOPIC_EVENT_TYPE,
  microcopySet: ModuleNames.MICROCOPY_SET,
  featuredSlider: ModuleNames.FEATURED_SLIDER,
}

export default moduleMapping
